import {
  CardContent,
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import React from 'react';
import Card, { CustomCardContainerProps } from '../../../../components/Card';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContentContainer: {
      overflowX: 'hidden',
      overflowY: 'auto',
      height: 'calc(100vh - 135px)',
      display: 'flex',
      padding: theme.spacing(1),
    },
    contentMaxHeight: {
      height: '100%',
      overflowY: 'auto',
    },
    cardImage: {
      width: 40,
      margin: '6px 6px 6px 0',
    },
  }),
);

interface InformatveCardProps
  extends Omit<CustomCardContainerProps, 'children'> {
  imgSrc: string;
  imgAltText: string;
  cardTitle: string;
  cardText: string;
  handleCardClick: (value: any) => any;
}

const InformativeCard: React.FC<InformatveCardProps> = (
  props: InformatveCardProps,
) => {
  const classes = useStyles();
  const {
    imgSrc,
    imgAltText,
    cardTitle,
    cardText,
    handleCardClick,
    ...rest
  } = props;

  return (
    <Card clickable style={{ height: '100%', minHeight: '150px' }} {...rest}>
      <CardContent onClick={handleCardClick}>
        <Grid container item direction="row" alignItems="center">
          <img className={classes.cardImage} src={imgSrc} alt={imgAltText} />
          <Typography
            variant="body1"
            color="textPrimary"
            style={{
              fontSize: '2.4vh',
              fontWeight: 'bold',
            }}
          >
            {cardTitle}
          </Typography>
        </Grid>
        <Typography
          variant="body1"
          color="textSecondary"
          style={{ marginTop: 10 }}
        >
          {cardText}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default InformativeCard;
